export const intlMessagesEn = {
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/locale/en.ts